import React, { useEffect, useMemo, useRef } from 'react'
import QueueManagement from './QueueManagement'
import { Container,Row,Col,Card, Alert } from 'reactstrap'
import Header from 'components/VerticalLayout/Header'
import bgImage from "../../assets/images/bgImage1.jpg";
import Sidebar from 'components/VerticalLayout/Sidebar';
import SuperAdminDash from './SuperAdminDash';
import { useLowBalanceAlert } from 'context/LowBalanceAlertContext';
import useGetWalletData from './Profile/hooks/useGetWalletData';
import { useQuery } from '@tanstack/react-query';


const Dashboard = () => {
  document.title = "Title Appraiser | Dashboard"
  
  const {setShowAlert } = useLowBalanceAlert();
  // const {data:wallet} = useGetWalletData();

  // const cachedData = JSON.parse(localStorage.getItem('userData') || {})
  const cachedData = useMemo(
    ()=> JSON.parse(localStorage.getItem('userData') || '{}'),[]
  )
  const role = cachedData.user.role;

  const {data: rawWallet} = useQuery({
    queryKey: ['userWallet'],
    enabled: false
  })

  const alertShownRef = useRef(false);

  useEffect(()=>{

    const source = rawWallet ?? cachedData?.wallet;
    if (!source) return;

    const wallet = Array.isArray(source?.results) ? source.results[0] : source;
    if (!wallet) return;

    const available =
      Number(wallet?.free_credit ?? 0) +
      Number(wallet?.paid_credit ?? 0);


    const threshold = Number(
      wallet?.threshold ?? 0
    );

    const alertEnabled = wallet?.low_bal_alert;

    const isLow = alertEnabled && available <= threshold;

    // if (alertEnabled && available <= threshold) {
    //   setShowAlert(true);
    // }

    if (isLow && !alertShownRef.current){
      setShowAlert(true);
      alertShownRef.current = true;
    }else if(!isLow) {
      alertShownRef.current = false
    }

  },[rawWallet,cachedData,setShowAlert])

  return (
    <div className='account-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"auto",
            paddingLeft:"8px"
            }}
        >
          <Container fluid>
            <Row>
              <Col>
                <Card style={{backdropFilter:"blur(10px)",opacity:"1"}}>
                  {role === "00000000-0000-0000-0000-000000000001" ? <SuperAdminDash/> :
                  <QueueManagement/>}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
  )
}

export default Dashboard